"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGlobalStyles = void 0;

var _stylitas = require("@creditas/stylitas");

var _constants = require("./constants");

const createGlobalStyles = (theme, custom) => (0, _stylitas.css)`
  /* Use resets */
  ${_constants.RESETS};

  /* Our globals */

  /**
   * Best practice from http://callmenick.com/post/the-new-box-sizing-reset
   * TLDR: It’s easier to override and a slight performance boost.
   */
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  html {
    box-sizing: border-box;
    [type='button'] {
      appearance: none;
    }
  }
  body {
    color: #4a4a4a;
    font-size: 16px;
  }

  /**
   * Form elements don't inherit font settings.
   * https://stackoverflow.com/questions/26140050/why-is-font-family-not-inherited-in-button-tags-automatically
   */
  html,
  body,
  input,
  select,
  optgroup,
  textarea,
  button {
    font-weight: 400;
    font-family: 'Nunito Sans', Tahoma;
    font-feature-settings: 'kern';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    text-rendering: optimizeLegibility;
  }

  /**
   * Allow custom styles to override the default styles
   */
  ${custom};
`;

exports.createGlobalStyles = createGlobalStyles;